import React, { FunctionComponent, useMemo } from 'react'

import { PROPERTY_TYPES } from '../../../common/drmTypes'
import {
  MonitoringExekuciFetchResult,
  TABLE_VIEW,
} from '../../../common/foreclosureMonitoringTypes'
import { defaultViewParam } from '../../utils/paths'
import { monitoringViewSlug } from '../../utils/tabsHelpers'
import { useUserActivityLogCheck } from '../../utils/useCheckUserActivityLog'
import { usePropertiesLabels } from '../../utils/usePropertiesLabels'
import { usePropertyTableNoteCheck } from '../../utils/usePropertyTableNoteCheck'
import { useTabKeyState } from '../../utils/useTabKeyState'
const ForeclosureMonitoringTable = React.lazy(
  () => import('../ForeclosureMonitoringTable/ForeclosureMonitoringTable')
)
const ForeclosureMonitoringTiles = React.lazy(
  () => import('../ForeclosureMonitoringTiles/ForeclosureMonitoringTiles')
)
import { MonitoringContentSuspense } from '../MonitoringContentSuspense/MonitoringContentSuspense'
import { PropertyMonitoringFetchError } from '../PropertyMonitoringFetchError/PropertyMonitoringFetchError'

export interface ForeclosureMonitoringContentProps {
  propertyType: PROPERTY_TYPES
  dataSource?: MonitoringExekuciFetchResult
}

export const ForeclosureMonitoringContent: FunctionComponent<ForeclosureMonitoringContentProps> =
  props => {
    const [viewType] = useTabKeyState<TABLE_VIEW>(
      TABLE_VIEW.TABLE,
      monitoringViewSlug,
      defaultViewParam
    )

    const propertyIds = useMemo(
      () => props.dataSource?.data?.data?.map(item => item.id) || [],
      [props.dataSource]
    )
    const propertiesActivity = useUserActivityLogCheck(propertyIds)
    const propertyNotes = usePropertyTableNoteCheck(propertyIds)
    const { propertyLabels, loading: labelsLoading } = usePropertiesLabels(
      propertyIds,
      props.propertyType
    )

    if (props.dataSource?.error)
      return <PropertyMonitoringFetchError type="exekucí" />

    return (
      <MonitoringContentSuspense>
        {viewType === TABLE_VIEW.TILES ? (
          <ForeclosureMonitoringTiles
            data={props.dataSource?.data?.data}
            propertyType={props.propertyType}
            userActivityLogs={propertiesActivity}
            propertyNotes={propertyNotes}
            propertyLabels={labelsLoading ? null : propertyLabels}
          />
        ) : (
          <ForeclosureMonitoringTable
            data={props.dataSource?.data?.data}
            propertyType={props.propertyType}
            userActivityLogs={propertiesActivity}
            propertyNotes={propertyNotes}
            propertyLabels={labelsLoading ? 'loading' : propertyLabels}
          />
        )}
      </MonitoringContentSuspense>
    )
  }
